import { get } from '..';

const getMyUser = () => get('users/v2/me');

export default getMyUser;
